import { jsx } from 'react/jsx-runtime';
import cns from '../../../../node_modules/classnames/index.js';
import useModalContext from './useModalContext.js';
import { ONLY_ONE_CHILD } from './utils.js';

/**
*/
function Item({ className = undefined, children = undefined, id, keepAliveWhenHidden = true, }) {
    const { current } = useModalContext();
    const hidden = current !== ONLY_ONE_CHILD && id !== current;
    if (hidden && !keepAliveWhenHidden) {
        return null;
    }
    return (jsx("div", { className: cns('v2-modal__item', { 'v2-modal__item--hidden': hidden }, className), children: children }));
}

export { Item as default };
